import { Pipe, PipeTransform } from '@angular/core';
 
@Pipe({
  name: 'faqhighlight',
  standalone: false
})

export class FaqhighlightPipe implements PipeTransform {
  transform(text: string, search: string): string {
    if (!search) return text;
    const pattern = search.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    const regex = new RegExp(`(${pattern})`, 'gi');
    return text.replace(regex, '<mark class="faqhighlight">$1</mark>');
  }
}